<template>
  <div class="post">
    <form class="hidden-on-mobile group">
      <input
        class="left-group"
        type="text"
        v-model="searchItem"
        placeholder="What do you want to learn?"
      />
      <button type="button" v-on:click="item" class="right-group">
        Search
      </button>
    </form>
    <p>{{ searchItem }}</p>
    <div class="info" v-if="videos">
      <h1>{{ videos[0].snippet.title }}</h1>
      <p>{{ videos[0].snippet.description }}</p>
      <img v-bind:src="videos[0].snippet.thumbnails.medium.url" />
      <a v-bind:href="'https://www.youtube.com/watch?v=' + videos[0].id.videoId"
        >Watch Video</a
      >
    </div>
  </div>
</template>

<script>
import Search from '../store/search'

export default {
  data() {
    return {
      videos: null,
      searchItem: null
    }
  },
  methods: {
    item() {
      Search(
        {
          apiKey: 'AIzaSyBbPKr0P_iy-ybWh0Aq3YJhHWFTrJp1ntw',
          term: this.searchItem
        },
        response => (this.videos = response)
      )
    }
  }
}
</script>

<style scoped>
.post {
  height: 20vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.info {
  height: 20vh;
  width: 50vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;
}
</style>
